/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import cn from 'classnames';
import _ from 'lodash';
import React from 'react';

import { ARRAY } from '../../constants';
import { PropertyComponent } from './PropertyComponent';

interface ObjectPropertiesProps {
  /**
   *
   */
  objectProperties: Record<string, any>;
  /**
   *
   */
  type: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  row: any;
  /**
   *
   */
  propIndex: number;
}
export const ObjectProperties = ({
  objectProperties,
  type,
  name,
  row,
  propIndex
}: ObjectPropertiesProps) => {
  return (
    <div
      className={cn({
        'CatalogOpenApiDataTable__operation-params-and-responses-item__ObjectType':
          !_.isEmpty(objectProperties)
      })}>
      {objectProperties &&
        !_.isEmpty(objectProperties) &&
        Object.entries(objectProperties).map(([nestedKey, nestedVal]) => {
          const nestedPropResponseType = _.get(nestedVal, 'type');
          const nestedObjectProperties = _.get(
            nestedVal,
            'items.properties',
            {}
          );
          const nestedName =
            nestedPropResponseType === ARRAY &&
            !_.isEmpty(nestedObjectProperties)
              ? name + '.' + nestedKey + '[ ]'
              : name + '.' + nestedKey;
          const required = Array.isArray(_.get(nestedVal, 'required'))
            ? _.get(nestedVal, 'required')?.includes(nestedKey)
            : false;
          const arrayType =
            nestedPropResponseType === ARRAY
              ? _.get(nestedVal, 'items.type')
              : '';
          return (
            <>
              {_.isEmpty(nestedObjectProperties) && (
                <PropertyComponent
                  type={type}
                  isNestedObj={true}
                  row={row}
                  name={nestedName}
                  propIndex={propIndex}
                  responseType={
                    nestedPropResponseType === ARRAY && arrayType
                      ? nestedPropResponseType.concat(`[${arrayType}]`)
                      : nestedPropResponseType
                  }
                  required={required}
                />
              )}
              <div
                className={cn({
                  'CatalogOpenApiDataTable__operation-params-and-responses-item__ObjectType-Nested':
                    !_.isEmpty(nestedObjectProperties)
                })}>
                {!_.isEmpty(nestedObjectProperties) && (
                  <ObjectProperties
                    objectProperties={nestedObjectProperties}
                    type={type}
                    name={nestedName}
                    row={row}
                    propIndex={propIndex}
                  />
                )}
              </div>
            </>
          );
        })}
    </div>
  );
};

export default ObjectProperties;
